import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { ProjectTemplatePopup } from './ProjectTemplatePopup';

const PROJECT_TEMPLATE_POPUP = Symbol('PROJECT_TEMPLATE');

/**
 * Use project template popup
 *
 * @returns {(function({
 *   onSubmit: function,
 *   [selectedTabType]: SIDEBAR_TAB_TYPE,
 *   [selectedTemplateTag]: TEMPLATE_TAG,
 *   [onCancel]: function
 * }): void)}
 */
export const useProjectTemplatePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(PROJECT_TEMPLATE_POPUP, ProjectTemplatePopup);
  });

  return useCallback(
    ({ selectedTabType, selectedTemplateTag, onSubmit, onCancel }) => {
      popups.openPopup(PROJECT_TEMPLATE_POPUP, {
        selectedTabType,
        selectedTemplateTag,

        onSubmit: (result) => {
          popups.closePopup(PROJECT_TEMPLATE_POPUP);
          onSubmit(result);
        },
        onClose: () => {
          popups.closePopup(PROJECT_TEMPLATE_POPUP);
          onCancel?.();
        },
      });
    },
    [popups]
  );
};
